import React from "react";
import { Routes, Route } from "react-router-dom";
import AppShell from "@/components/AppShell";
import Overview from "@/components/Overview";
import Clients from "@/components/Clients";
import Deadlines from "@/components/Deadlines";
import Documents from "@/components/Documents";
import Invoices from "@/components/Invoices";
import Assistant from "@/components/Assistant";

const Dashboard = () => (
  <AppShell>
    <Routes>
      <Route index element={<Overview />} />
      <Route path="clients" element={<Clients />} />
      <Route path="deadlines" element={<Deadlines />} />
      <Route path="documents" element={<Documents />} />
      <Route path="invoices" element={<Invoices />} />
      <Route path="assistant" element={<Assistant />} />
    </Routes>
  </AppShell>
);

export default Dashboard;
